var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguredance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.3867 29.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.543,
    opacity: 0,
    width: 15.3867,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71094 28.7812C2.39062 28.7812 2.89453 28.2656 2.89453 27.6328L2.89453 22.0195L6.17578 18.5273C6.23438 18.4688 6.33984 18.4688 6.39844 18.5391L9.53906 22.7461L12.2109 28.0547C12.9492 29.543 15.0352 28.4766 14.3203 27.0586L8.83594 16.0664C8.34375 15.082 8.09766 13.7578 7.98047 12.4102C7.94531 11.9766 8.22656 11.7656 8.60156 11.9531L10.7695 13.0547L12.7734 17.0625C13.4883 18.4805 15.6328 17.5195 14.8711 16.0078L12.6914 11.6602C12.5742 11.4258 12.3984 11.25 12.1641 11.1328L9.04688 9.57422C8.12109 9.10547 7.17188 8.92969 6.29297 8.70703C5.28516 8.46094 4.38281 8.14453 3.77344 7.27734L2.35547 5.21484L2.35547 1.16016C2.35547 0.527344 1.81641 0 1.17188 0C0.527344 0 0 0.527344 0 1.16016L0 5.58984C0 5.84766 0.0585938 6.02344 0.210938 6.24609L2.69531 9.83203C2.91797 10.1602 3.05859 10.3711 3.10547 10.9219C3.19922 12.2227 3.48047 14.6367 4.00781 16.3828L0.773438 20.8711C0.621094 21.1055 0.5625 21.3281 0.5625 21.5508L0.5625 27.6328C0.5625 28.2656 1.06641 28.7812 1.71094 28.7812ZM7.10156 7.44141C8.50781 7.44141 9.64453 6.30469 9.64453 4.875C9.64453 3.46875 8.50781 2.33203 7.10156 2.33203C5.67188 2.33203 4.53516 3.46875 4.53516 4.875C4.53516 6.30469 5.67188 7.44141 7.10156 7.44141Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguredance);
export default __webpack_public_path__ + "static/media/figure.dance.be19e2b808f1d909c4f5aa2ae0cabd55.svg";
export { ForwardRef as ReactComponent };